// check if this game is the last game in course

import _ from 'lodash';

// (to decide if it be graded or not)
export const isThisGameLastInCourse = (
  course: object = {},
  gameResourceId: string
) => {
  let found = false;
  let isLastInCourse = true;
  // @ts-ignore
  _.forEach(course?.pages, (p) => {
    if (!!p?.resourceId && p.resourceId === gameResourceId) {
      found = true;
    } else if (
      (found && p.resourceType === 'game') ||
      p.resourceType === 'quiz'
    ) {
      isLastInCourse = false;
    }
  });
  return isLastInCourse;
};
